import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

const modifiers = {
  vaccine: ({ theme }) => ({
    styles: `
      background-color: ${theme.primary.yellow};
    `,
  }),
  limitedHospital: ({ theme }) => ({
    styles: `
      background-color: ${theme.primary.lightGreen};

    `,
  }),
  fullHospital: ({ theme }) => ({
    styles: `
      background-color: ${theme.primary.pink}50;
    `,
  }),
  dynamicHospital: ({ theme }) => ({
    styles: `
      background-color: ${theme.primary.purple};
    `,
  }),
};

export const ShiftLabelStyled = styled.div.attrs({
  className: 'ShiftLabelStyled',
})`
  width: fit-content;
  padding: 0.1875rem 0.375rem;
  border-radius: 0.25rem;

  .Text {
    margin-bottom: 0;
    font-weight: bold;
    line-height: normal;
    font-size: 0.75rem;
    position: relative;
    top: 1px;
  }
  ${applyStyleModifiers(modifiers)};
`;

export const DateWrapper = styled.div.attrs({
  className: 'DateWrapper',
})`
  margin-right: 0.5rem;

  .Text {
    font-size: 0.875rem;
  }
`;

export const LabelWrapper = styled.div.attrs({
  className: 'LabelWrapper',
})`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: .5rem;
  opacity: ${({ isDisabled }) => isDisabled ? 0.25 : 1};
`;
